"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputSearch = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
const button_1 = require("../FieldControl/button");
exports.SmInputSearch = (0, react_1.forwardRef)((_a, ref) => {
    var { id, value = '', message, messageIcon = (react_1.default.createElement(Icon_1.SmIcon, { name: "error_outline", size: "small", type: "outlined" })), searchIcon = react_1.default.createElement(Icon_1.SmIcon, { name: "search" }), searchIconTitle = 'Pesquisar', onSearch, clearIcon = react_1.default.createElement(Icon_1.SmIcon, { name: "clear" }), clearIconTitle = 'Limpar campo', onClear, className } = _a, props = __rest(_a, ["id", "value", "message", "messageIcon", "searchIcon", "searchIconTitle", "onSearch", "clearIcon", "clearIconTitle", "onClear", "className"]);
    const [inputValue, setInputValue] = (0, react_1.useState)(value);
    const [showClearIcon, setShowClearIcon] = (0, react_1.useState)(value !== '');
    const updateField = (text) => {
        setShowClearIcon(text !== '');
        setInputValue(text);
    };
    const controlClassName = 'c-control -search';
    const InputClassName = (0, classnames_1.default)('c-control__input');
    const fieldClassName = (0, classnames_1.default)('c-field -search', {
        '-disabled': props.disabled,
        className,
    });
    return (react_1.default.createElement("div", { className: fieldClassName },
        react_1.default.createElement("div", { className: controlClassName },
            react_1.default.createElement("input", Object.assign({}, props, { id: id, ref: ref, value: inputValue, type: "search", disabled: props.disabled, className: InputClassName, onChange: (e) => updateField(e.target.value), "aria-describedby": message ? `${id}-description` : '' })),
            showClearIcon && (react_1.default.createElement(button_1.SmInputButtonTemplate, { onClick: (e) => {
                    updateField('');
                    onClear === null || onClear === void 0 ? void 0 : onClear(e);
                }, title: clearIconTitle, icon: clearIcon, disabled: props.disabled })),
            react_1.default.createElement(button_1.SmInputButtonTemplate, { onClick: (e) => {
                    onSearch === null || onSearch === void 0 ? void 0 : onSearch(e);
                }, title: searchIconTitle, icon: searchIcon, disabled: props.disabled })),
        message && (react_1.default.createElement("small", { id: `${id}-description`, className: "c-field__description" },
            messageIcon,
            message))));
});
//# sourceMappingURL=index.js.map